import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [
		"formTypeSelection",
		"insuranceForm",
		"investorForm",
		"profileSelect",
    "profileForm",
  ]

  connect() {
		// console.log("Stimulus modal connected!");
    // Reset state when the modal is hidden
    $('#chooseProfile').on('hidden.bs.modal', () => this.reset())

		// Listen for select2:select and call selectProfile
		// $('#profile_id').on('select2:select', () => {}
		if (this.hasProfileSelectTarget) {
			// console.log("Profile select found!!");
			$(this.profileSelectTarget).on('select2:select', (event) => this.selectProfile(event));
		}
  }

  selectProfile(event) {
		// console.log("selectProfile: ", event.target.value);
    if (event.target.value === 'new_investor') {
      this.profileFormTarget.style.display 				= 'none'
      this.formTypeSelectionTarget.style.display	= ''
      this.investorFormTarget.style.display 			= ''
    }
  }

  showInvestor() {
    this.investorFormTarget.style.display		= ''
    this.insuranceFormTarget.style.display	= 'none'
  }

  showInsurance() {
    this.investorFormTarget.style.display		= 'none'
    this.insuranceFormTarget.style.display	= ''
  }

  reset() {
    this.profileFormTarget.style.display				= 'flex'
    this.formTypeSelectionTarget.style.display	= 'none'
    this.investorFormTarget.style.display				= 'none'
    this.insuranceFormTarget.style.display			= 'none'
  }
}